import { render, staticRenderFns } from "./CyberbizTagListChange.vue?vue&type=template&id=4465ef8b&scoped=true&"
import script from "./CyberbizTagListChange.vue?vue&type=script&lang=js&"
export * from "./CyberbizTagListChange.vue?vue&type=script&lang=js&"
import style0 from "./CyberbizTagListChange.vue?vue&type=style&index=0&id=4465ef8b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4465ef8b",
  null
  
)

export default component.exports